import React from 'react';

interface SubjectCardProps {
  subject: {
    id: string;
    name: string;
    questionCount?: number;
  };
  index: number;
  onClick: (subject: { id: string; name: string; totalQuestions: number }) => void;
}

export const SubjectCard: React.FC<SubjectCardProps> = ({ subject, index, onClick }) => {
  // Funzioni per i colori dinamici con gradienti alpha
  const getCardColor = (index: number) => {
    const colors = [
      'from-blue-500/20 to-blue-600/30',
      'from-green-500/20 to-green-600/30', 
      'from-purple-500/20 to-purple-600/30',
      'from-pink-500/20 to-pink-600/30',
      'from-indigo-500/20 to-indigo-600/30',
      'from-teal-500/20 to-teal-600/30',
      'from-orange-500/20 to-orange-600/30',
      'from-red-500/20 to-red-600/30'
    ];
    return colors[index % colors.length];
  };

  const getOverlayColor = (index: number) => {
    const colors = [
      'from-blue-600/30 to-blue-700/40',
      'from-green-600/30 to-green-700/40',
      'from-purple-600/30 to-purple-700/40', 
      'from-pink-600/30 to-pink-700/40',
      'from-indigo-600/30 to-indigo-700/40',
      'from-teal-600/30 to-teal-700/40',
      'from-orange-600/30 to-orange-700/40',
      'from-red-600/30 to-red-700/40'
    ];
    return colors[index % colors.length];
  };

  const getFontSize = (name: string) => {
    if (name.length <= 10) return 'text-lg sm:text-xl';
    if (name.length <= 20) return 'text-base sm:text-lg';
    if (name.length <= 30) return 'text-sm sm:text-base';
    return 'text-xs sm:text-sm';
  };

  const handleClick = (e: React.MouseEvent) => {
    console.log('🖱️ [DEBUG] CLICK SU CARD! Materia:', subject.name, subject.id);
    e.preventDefault();
    e.stopPropagation();
    onClick({
      id: subject.id,
      name: subject.name,
      totalQuestions: subject.questionCount || 100
    });
  };

  return (
    <div
      key={subject.id}
      onClick={handleClick}
      className={`group relative overflow-hidden rounded-xl bg-gradient-to-br ${getCardColor(index)} shadow-lg hover:shadow-xl transition-all duration-300 h-40 cursor-pointer`}
    >
      <div className={`absolute inset-0 bg-gradient-to-br ${getOverlayColor(index)} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
      
      {/* Contenuto principale */}
      <div className="relative p-6 h-full flex flex-col bg-white/10 backdrop-blur-sm rounded-xl">
        {/* Titolo - occupa 3 righe con font dinamico */}
        <div className="flex-1 flex items-center">
          <h3 className={`${getFontSize(subject.name)} font-bold text-gray-800 group-hover:text-white transition-colors duration-300 line-clamp-3 leading-tight w-full text-center drop-shadow-sm`}>
            {subject.name}
          </h3>
        </div>
        
        {/* Numero domande - bottom con padding */}
        <div className="mt-auto pb-2">
          <span className="text-sm text-gray-700 font-medium bg-white/90 px-3 py-1 rounded-full shadow-sm backdrop-blur-sm">
            {subject.questionCount || 0} domande
          </span>
        </div>
      </div>
    </div>
  );
};
